export const languageOptions = [
  { code: "en", name: "English" },
  { code: "pt", name: "Português" },
  { code: "zh", name: "中國" },
  { code: "it", name: "Italiano" },
  { code: "fr", name: "Français" },
  { code: "es", name: "Español" },
  { code: "se", name: "Svenska" },
  { code: "de", name: "Deutsch" },
  { code: "cs", name: "Czech" },
  { code: "zh-HANT", name: "繁體中文" },
  { code: "pl", name: "Polski" },
  { code: "fi", name: "Suomi" },
  { code: "tr", name: "Türkçe" },
  { code: "vi", name: "Tiếng Việt" },
  { code: "ru", name: "Pусский" },
  { code: "nl", name: "Nederlands" },
  { code: "ko", name: "한국어" },
  { code: "jp", name: "日本" },
  { code: "hu", name: "Magyar" },
];
